
import {css} from '@emotion/react';
import { Colors } from '@vc-workspace/utils-colors';

export const containerStyles = css({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: Colors.white,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  zIndex: 50
});

export const transitionContainerStyles = css({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  background: Colors.white_60,
  zIndex: 50
});